/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/141-shrink2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7 9v6.5L4.5 13l-3 3L0 14.5l3-3L.5 9zm9-7.5l-3 3L15.5 7H9V.5L11.5 3l3-3z"/>'
  }
})
